// extracted by mini-css-extract-plugin
export default {"loader":"IcL6rN"};